import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-1" }
const _hoisted_2 = { class: "grid-2" }
const _hoisted_3 = { class: "grid-2" }

import Label from "@ui-kit/label/Label.vue";
import ValidationKeyObserver from "@components/validation/ValidationKeyObserver.vue";
import { SingleSelect, useSelectServerDataManager, useSelectClientDataManager } from "@ui-kit/inputs/select";
import SingleLine from "@ui-kit/inputs/single-line/SingleLine.vue";
import MultiLine from "@ui-kit/inputs/multi-line/MultiLine.vue";
import { RepairOrderResource } from '@shared/resources/repair-order';
import { OrderCreateUpdateDto } from '../dto';
import { computed, ref, watch } from 'vue';
import { ClientResource } from '@shared/resources/client';
import { OrderType, OrderTypeList, OrderTypeNameMap } from '@shared/types/order-type';
import { useI18n } from 'vue-i18n';
import { CarResource } from '@shared/resources/car';
import ClientSelect from '@/pages/partials/client-select/ClientSelect.vue';

interface Props {
  data: RepairOrderResource;
  formData: OrderCreateUpdateDto;
  type?: OrderType;
  client?: ClientResource;
}
interface Emits {
  (type: 'update', event: Partial<OrderCreateUpdateDto>): void;
}
interface OrderTypeOption {
  id: OrderType;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabMain',
  props: {
    data: null,
    formData: null,
    type: null,
    client: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'update', event: Partial<OrderCreateUpdateDto>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: RepairOrderResource;
  formData: OrderCreateUpdateDto;
  type?: OrderType;
  client?: ClientResource;
}

const { t } = useI18n();





const selectedClient = ref<ClientResource | undefined>(props.client || props.data?.client || undefined);
watch(selectedClient, (value) => {
  emit('update', {
    client_id: value?.id || undefined,
  });
  selectedCar.value = undefined;
});

const selectedCar = ref<CarResource | undefined>(props.data?.car || undefined);
watch(selectedCar, (value) => {
  emit('update', {
    car_id: value?.id || undefined,
  });
});
const carsSelectManager = useSelectServerDataManager({
  path: 'cars/grid',
  filters: computed(() => {
    return selectedClient.value
      ? { 'client.id': selectedClient.value.id }
      : {};
  }),
})

const orderTypeOptions = computed<OrderTypeOption[]>(() => {
  return OrderTypeList.map((id) => ({
    id,
    name: t(`common.order_type.${OrderTypeNameMap[id]}`),
  }));
});
const selectedOrderType = computed<OrderTypeOption>(() => {
  return orderTypeOptions.value.find(({id}) => id === props.formData.type) as OrderTypeOption;
});
function chooseOrderType(type: OrderTypeOption) {
  emit('update', {
    type: type.id,
  });
}
const orderTypeSelectManager = useSelectClientDataManager({
  data: orderTypeOptions,
  selected: selectedOrderType,
  hideSelected: true,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Label, {
        label: _ctx.$t('fields.date')
      }, {
        default: _withCtx(({ id }) => [
          _createVNode(ValidationKeyObserver, { keys: "date" }, {
            default: _withCtx(({ firstErrorMessage }) => [
              _createVNode(SingleLine, {
                id: id,
                errors: firstErrorMessage,
                modelValue: __props.formData.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.formData.date) = $event)),
                mask: "##.##.####"
              }, null, 8, ["id", "errors", "modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(Label, {
        label: _ctx.$t('fields.type')
      }, {
        default: _withCtx(() => [
          _createVNode(ValidationKeyObserver, { keys: "type" }, {
            default: _withCtx(({ firstErrorMessage }) => [
              _createVNode(_unref(SingleSelect), {
                "data-manager": _unref(orderTypeSelectManager),
                "model-value": _unref(selectedOrderType),
                "onUpdate:modelValue": chooseOrderType,
                "hide-empty": "",
                "disable-search": "",
                errors: firstErrorMessage
              }, null, 8, ["data-manager", "model-value", "errors"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Label, {
        label: _ctx.$t('fields.client')
      }, {
        default: _withCtx(() => [
          _createVNode(ValidationKeyObserver, { keys: "client_id" }, {
            default: _withCtx(({ firstErrorMessage }) => [
              _createVNode(ClientSelect, {
                errors: firstErrorMessage,
                disabled: !!__props.client,
                modelValue: selectedClient.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedClient).value = $event))
              }, null, 8, ["errors", "disabled", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      (__props.formData.type !== _unref(OrderType).ORDER)
        ? (_openBlock(), _createBlock(Label, {
            key: 0,
            label: _ctx.$t('fields.car')
          }, {
            default: _withCtx(() => [
              _createVNode(ValidationKeyObserver, { keys: "car_id" }, {
                default: _withCtx(({ firstErrorMessage }) => [
                  _createVNode(_unref(SingleSelect), {
                    "data-manager": _unref(carsSelectManager),
                    modelValue: selectedCar.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCar).value = $event)),
                    "select-option-text": _ctx.$t('pages.common.select-car'),
                    disabled: !selectedClient.value,
                    errors: firstErrorMessage
                  }, {
                    "selected-option": _withCtx(({ value }) => [
                      _createTextVNode(_toDisplayString(value.car_model.car_brand.name) + " " + _toDisplayString(value.car_model.name) + " " + _toDisplayString(value.registration_plate), 1)
                    ]),
                    option: _withCtx(({ option }) => [
                      _createTextVNode(_toDisplayString(option.car_model.car_brand.name) + " " + _toDisplayString(option.car_model.name) + " " + _toDisplayString(option.registration_plate), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-manager", "modelValue", "select-option-text", "disabled", "errors"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Label, {
      label: _ctx.$t('fields.notes')
    }, {
      default: _withCtx(({ id }) => [
        _createVNode(ValidationKeyObserver, { keys: "notes" }, {
          default: _withCtx(({ firstErrorMessage }) => [
            _createVNode(MultiLine, {
              id: id,
              errors: firstErrorMessage,
              modelValue: __props.formData.notes,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.formData.notes) = $event)),
              lines: 6
            }, null, 8, ["id", "errors", "modelValue"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}
}

})